import { render, staticRenderFns } from "./Information_mobile.vue?vue&type=template&id=d1d9f2f2&scoped=true&"
import script from "./Information_mobile.vue?vue&type=script&lang=js&"
export * from "./Information_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Information_mobile.vue?vue&type=style&index=0&id=d1d9f2f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d9f2f2",
  null
  
)

export default component.exports